// Libraries
import { HeaderLayout } from '../../layouts';
import { Card, Alert, FormElems, LoginFlowComps, Otp } from '../../components';
import { loginRequest, loginError } from '../../redux/common/auth/auth.actions';
import { getLoginRedirectPath } from '../../utils/helperMethods';
import loginImg from '../../static/images/loginimg.png';
import validate from './validator';
import React, { useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';

// Layouts

// Components

// Actions

// Helper Methods

// Images

// Validator

// Styles
import './login.scss';

const Login = props => {
    const { handleSubmit, actions, auth } = props;
    const { checkOtp } = auth;
    const history = useHistory();

    const getRedirectPath = useMemo(
        () =>
            getLoginRedirectPath(
                auth.resourceDetails.resources,
                auth.resourceDetails.permissions
            ),
        [auth.resourceDetails.resources, auth.resourceDetails.permissions]
    );

    const redirectPath = getRedirectPath;

    useEffect(() => {
        if (auth.isLoggedIn) {
            history.push(redirectPath);
        }
    }, [history, auth.isLoggedIn, redirectPath]);

    // Reset login error
    const resetLoginError = useCallback(() => {
        if (auth.loginError) {
            actions.loginError({ loginError: '' });
        }
    }, [actions, auth.loginError]);

    useEffect(() => {
        return () => {
            // Reset login error
            resetLoginError();
        };
    }, [resetLoginError]);

    /**
     * Called on login form submit
     *
     * @param {Object} values - Object of all form field values
     * @returns {undefined}
     */
    function handleLoginSubmit(values) {
        actions.loginRequest(values);
    }

    return (
        <HeaderLayout>
            {!auth.isLoggedIn ? (
                <>
                    {checkOtp ? (
                        <Otp />
                    ) : (
                        <div className="login-wrapper">
                            <Card customClass="login-card">
                                <LoginFlowComps.ImageSplitView
                                    splitImg={loginImg}
                                >
                                    <div className="login-form-wrapper">
                                        <div className="form-head">LOGIN</div>
                                        <form
                                            className="login-form"
                                            onSubmit={handleSubmit(
                                                handleLoginSubmit
                                            )}
                                            onChange={resetLoginError}
                                        >
                                            <div className="form-field">
                                                <p className="label">
                                                    Email ID
                                                </p>
                                                <Field
                                                    name="emailId"
                                                    type="text"
                                                    component={FormElems.Input}
                                                    placeholder="Enter Email ID"
                                                    id="emailInputLogin"
                                                />
                                            </div>
                                            <div className="form-field">
                                                <p className="label">
                                                    Password
                                                </p>
                                                <Field
                                                    name="password"
                                                    type="password"
                                                    id="passwordInputLogin"
                                                    component={FormElems.Input}
                                                    placeholder="Enter Password"
                                                    wrapperClass="password-field"
                                                />
                                                <Link
                                                    to="/forgotpassword"
                                                    className="forgot-link"
                                                >
                                                    Forgot?
                                                </Link>
                                            </div>

                                            {auth.loginError && (
                                                <Alert customClass="login-alert">
                                                    {auth.loginError}
                                                </Alert>
                                            )}

                                            <div className="form-btn">
                                                <FormElems.Button
                                                    id="continueCTA"
                                                    buttonType="primary"
                                                    text="CONTINUE"
                                                />
                                            </div>
                                        </form>
                                    </div>
                                </LoginFlowComps.ImageSplitView>
                            </Card>
                        </div>
                    )}
                </>
            ) : null}
        </HeaderLayout>
    );
};

Login.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    handleSubmit: PropTypes.func,
};

const mapStateToProps = ({ auth }) => ({
    auth,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            loginRequest,
            loginError,
        },
        dispatch
    ),
});

export default compose(
    reduxForm({
        form: 'login',
        validate,
    }),
    connect(mapStateToProps, mapDispatchToProps)
)(Login);
